import { Editor } from '../../components/editor/editor';
import { useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLoadStore, clearStore, setFileName } from '../../state-manager/slices/preferences';
import { getTemplate as getLocalTemplate } from '../../services/templateService';
import { getTemplate as getApiTemplate } from '../../services/overlayApi';
import { designsApi } from '../../services/designsApi';

const Builder = () => {
    const location = useLocation();
    const { templateId, creativeId } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        const loadTemplate = async () => {
            // Always clear the store first to prevent stale canvas data
            dispatch(clearStore());

            // 1. Check if creativeId is from URL params (Creative mode)
            if (creativeId) {
                try {
                    const design = await designsApi.get(creativeId);
                    if (design) {
                        // Check for canvas_data (new preferred field) or legacy fields
                        const designData = design.canvas_data || design.polotno_data || (design.template && (design.template.design_data || design.template.canvas_data));
                        
                        if (designData) {
                             dispatch(setLoadStore(designData));
                        }
                        if (design.name) {
                            dispatch(setFileName(design.name));
                        }
                    }
                } catch (error) {
                    console.error('Failed to load design from API:', error);
                }
            }
            // 2. Check if templateId is from URL params (API template mode - likely legacy or admin)
            else if (templateId) {
                try {
                    const template = await getApiTemplate(templateId);
                    if (template && (template.design_data || template.canvas_data)) {
                        // Load the template JSON into the store
                        dispatch(setLoadStore(template.design_data || template.canvas_data));
                    }
                } catch (error) {
                    console.error('Failed to load template from API:', error);
                }
            } 
            // 3. Check if a template ID was passed from navigation state (local template)
            else if (location.state?.templateId) {
                const template = getLocalTemplate(location.state.templateId);
                if (template) {
                    // Load the template JSON into the store
                    dispatch(setLoadStore(template.json));
                }
            }
        };

        loadTemplate();
    }, [templateId, creativeId, location.state, dispatch]);

    return <Editor templateId={templateId} creativeId={creativeId} />;
}

export default Builder;